// extracted by mini-css-extract-plugin
module.exports = {"top_img":"top_img-2XDidKGL","closed":"closed-3ufh3pih","a_link":"a_link-OCpqrp9M"};